import BaseApi from "../base";

export default class Requests extends BaseApi {

}

